<rask-page
  pageTitle="Kontraktsmigrering"
  noPadding>
  <ng-container headerContent>
    <div class="row">
      <rask-input
        class="col-3"
        label="Kontraktnummer"
        [(ngModel)]="kontraktnummer">
      </rask-input>
    </div>
    <div class="row">
      <div class="col-6">
        <rask-button
          class="col-3"
          (click)="onKontraktnummerSelected()">
          Sök
        </rask-button>
        <rask-button
          class="col-3"
          color="primary"
          (click)="addKontraktnummer()">
          Lägg till
        </rask-button>
        <rask-button (click)="copyFromClipboard()">Matcha från clipboard</rask-button>
      </div>
    </div>
  </ng-container>
  @if (rows) {
    <rask-table #table [editable]="false" [data]="rows" [options]="gridOptions" [columns]="tableColumns"
      [noScroll]="true">
    </rask-table>
  }
  <ng-container footer>
    <rask-button color="secondary" [disabled]="!canSave()" (click)="saveAll()">Spara</rask-button>
  </ng-container>
</rask-page>